import React, { useRef } from 'react';

const Search = ({ searchTerm, onChange }) => {
  const inputRef = useRef(null);

  const handleIconClick = () => {
    inputRef.current?.focus();
  };

  return (
    <div className="search center-align">
      <div className="row">
        <div className="input-field col s12" style={{ position: 'relative' }}>
          <input
            ref={inputRef}
            id="search"
            type="text"
            className="validate"
            value={searchTerm}
            onChange={(e) => onChange(e.target.value)}
          />

          <label htmlFor="search">Search for repositories...</label>

          <i
            className="material-icons search-icon"
            onClick={handleIconClick}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
            }}
          >
            search
          </i>
        </div>
      </div>
    </div>
  );
};

export default Search;
